import React, {Component} from 'react'
import { Menu } from './../Menu/Menu'
// eslint-disable-next-line
import { BrowserRouter as Router, Route, NavLink } from 'react-router-dom'
import './Header.css'

class Header extends Component {
	render(){
		return (
			<div className="header-container">
				<div className="header-light-bg"></div>
				<div className="header-menu-container">
					<Menu changePage={ this.changePage }/>
				</div>

				<NavLink exact to="/">
					<div className="header-logo"></div>
				</NavLink>
			</div>
		)
	}
}

export default Header


// WEBPACK FOOTER //
// ./src/components/Header/Header.js